/**
 *
 * @returns {void}
 */
export default class SortOptions {
  /**
   * Constructor
   *
   * @returns {void}
   */
  constructor() {
    // Set scope
    const scope = document.body;

    this.boundToggleOptions = (e) => this.toggleOptions(e);
    this.boundCloseOptions = (e) => this.closeOptions(e);

    // Get elements
    this.button = scope.querySelector(".sort-button ");
    this.options = scope.querySelector(".sort-options");

    this.init();
  }

  /**
   * Add event listeners
   *
   * @returns {void}
   */
  init() {
    if (this.button) {
      this.button.addEventListener("click", this.boundToggleOptions, true);

      document.addEventListener(
        "click",
        (e) => this.boundCloseOptions(e),
        true,
      );
    }
  }

  toggleOptions() {
    this.button.classList.toggle("open");
    this.options.classList.toggle("hidden");
  }

  closeOptions(e) {
    if (e.target === this.button || e.target === this.options) return;

    this.button.classList.remove("open");
    this.options.classList.add("hidden");
  }
}
